(function() {
  'use strict';

  angular
    .module('contentPlayer.sendPreviewCtrl', [])
    .controller('SendPreviewCtrl', SendPreviewCtrl);

  SendPreviewCtrl.$inject = ['$scope', 'ContentPlayerService', '$routeParams'];

  function SendPreviewCtrl($scope, ContentPlayerService, $routeParams) {
    var emailInfo = $scope.emailInfo = {
      cModuleId: $routeParams.cModuleId,
      email: ''
    };
    $scope.sendPreview = function() {
      ContentPlayerService.sendPreview(emailInfo, function() {
        $scope.$close();
      });
    };
  }
})();
